export const dropdownCustomStyles = () => ({
  root: {
    width: 'auto',
    border: 'none',
    padding: 0,
    margin: 0,
  },
  dropdown: {
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
    padding: 2,
    margin: 2,
    minWidth: '150px',
    selectors: {
      ':focus': {
        outline: 'none',
      },
      ':focus:after': {
        border: 'none',
        outline: 'none',
      },
    },
  },
  title: {
    backgroundColor: 'transparent',
    border: 'none',
    paddingTop: 0,
    height: 'auto',
    lineHeight: 'normal',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    selectors: {
      ':focus': {
        outline: 'none',
        border: 'none',
        boxShadow: 'none',
      },
      ':focus-visible': {
        outline: 'none',
        border: 'none',
        boxShadow: 'none',
      },
    },
  },
  caretDown: {
    fontSize: 12,
    marginLeft: 4,
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
  },
  caretDownWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  dropdownItem: {
    padding: '4px 8px',
    margin: 0,
  },
});
